module.exports = __webpack_public_path__ + "static/img/vb.b1c9512.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/header/soc/vb.jpg
// module id = TLU6
// module chunks = 1